import { createUseQuery } from 'api/common/createUseQuery'
import { fetchProjects } from 'api/fetchers/fetchProjects'
import { ApiQueryKeys } from 'constants/apiQueryKeys'
import { ApiResponse } from 'types/common/utils'
import { Project } from 'types/Project'

export const useProjects = createUseQuery({
  queryKey: ApiQueryKeys.PROJECTS,
  fetcher: fetchProjects,
  selector: res => (res?.data as ApiResponse<Project> | undefined) ?? ({} as ApiResponse<Project>),
})
